import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import './Navbar.css'
import logo from '../../Assets/logo.png'

const Navbar = () => {
  const [showAdditionalLinks, setShowAdditionalLinks] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isContentVisible, setContentVisible] = useState(false);

  const openSidebar = () => {
    setSidebarOpen(true);
    setTimeout(() => setContentVisible(true), 300); // Delay to show content
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleImageClick = () => {
    setShowAdditionalLinks(!showAdditionalLinks);
  };



  return (
    <div>
      <div
        className='z-40 px-4 flex justify-between items-center h-[80px] shadow-xl fixed w-full top-0 left-0 transition-all duration-300 bg-[#121A31]'
      >
        <div className='flex md:w-[90%] lg:w-[80%] lg:px-20 lg:pl-60 justify-between'>

          <div className="flex items-center pt-5 text-zinc-50 font-bold">
            <Link to={'/'} className="flex items-center">
              <img
                src={logo}
                alt="KayDeeTech Logo"
                className="h-8 w-8 object-cover"
              />
              <h1
                className= 'text-whit px-5 cursor-default text-lg md:text-xl lg:text-xl -mt-1 cursor-pointer'
              >
                KayDeeTech.
              </h1>
            </Link>
          </div>
          <div className="lg:hidden md:hidden">
            <GiHamburgerMenu
              className="ml-5 cursor-pointer pt-6"
              width={25}
              height={30}
              alt="Hamburgur Menu"
              onClick={handleImageClick}
            />
          </div>

          <nav className='hidden mt-2 lg:flex md:flex gap-10'>
            <ul className="navbar-links mt-2 gap-10">
              <Link to={'/'}>
                <li
                  className='text-lg font-bold cursor-pointer text-white hover:text-[#124E66]'
                >
                  Home
                </li>
              </Link>
              <Link to={'/about'}>
                <li
                  className='text-lg font-bold cursor-pointer text-[#121A31] text-white hover:text-[#124E66]'
                >
                  About
                </li>
              </Link>
              <Link to={'/services'}>
                <li
                  className='text-lg font-bold cursor-pointer text-[#121A31] text-white hover:text-[#124E66]'
                >
                  Services
                </li>
              </Link>
            </ul>

            <div>
              <Link to='/contactus'>
                <button className='text-white hover:bg-[#124E66] rounded-full border-[2px] border-zinc-600 py-2 px-3 hover:duration-300 w-40'>
                  Contact Us
                </button>
              </Link>
            </div>
          </nav>
        </div>
        <div class="hamburger" onClick={openSidebar}>
          <div class="hamburger__container">
            <div class="hamburger__inner"></div>
            <div class="hamburger__hidden"></div>
          </div>
        </div>
        {/* Sidebar */}
        {isSidebarOpen && (
          <div className="fixed top-0 right-0 h-screen w-[300px] bg-[#124E66] text-white z-50 shadow-lg flex flex-col py-8">
            {/* Close Button */}
            <button
              onClick={toggleSidebar}
              className="absolute top-4 right-4 text-white text-2xl"
            >
              &times;
            </button>

            {/* Links */}
            <ul className="mt-20 space-y-8">
              <Link to={'/'} onClick={toggleSidebar}>
                <li className=" hover:bg-[#145E76] py-4 text-center text-lg font-medium tracking-wide rounded-md transition-colors">
                  Home
                </li>
              </Link>
              <Link to={'/about'} onClick={toggleSidebar}>
                <li className=" hover:bg-[#145E76] py-4 text-center text-lg font-medium tracking-wide rounded-md transition-colors">
                  About
                </li>
              </Link>
              <Link to={'/services'} onClick={toggleSidebar}>
                <li className=" hover:bg-[#145E76] py-4 text-center text-lg font-medium tracking-wide rounded-md transition-colors">
                  Services
                </li>
              </Link>
              <Link to={'/contactus'} onClick={toggleSidebar}>
                <li className=" hover:bg-[#145E76] py-4 text-center text-lg font-medium tracking-wide rounded-md transition-colors">
                  Contact Us
                </li>
              </Link>
            </ul>
          </div>
        )}

      </div>
    </div>
  )
}
export default Navbar;